import { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, Form, Nav, NavDropdown, Navbar, Row } from 'react-bootstrap';
import Datetime from "react-datetime";
import moment from 'moment';
import { IProtestSearchParameters, ProtestOutcome, protestOutcomeToText, ProtestStatus, protestStatusToText, ProtestType, protestTypeToText } from '../../types/Protest';

export interface MainSearchBarComponentProps {
  protestSearchParameters: IProtestSearchParameters;
  updated: (params: IProtestSearchParameters) => void;
  resetSearchParameters: () => void;
}

const MainSearchBarComponent = (props: MainSearchBarComponentProps) => {
  const games = ["rf2", "lmu"];
  const protestTypes = [ProtestType.ChatAbuse, ProtestType.IntentionalWrecking, ProtestType.CausingCollision, ProtestType.UsernameViolation, ProtestType.TeamNameViolation, ProtestType.LiveryViolation];
  const statuses = [ProtestStatus.Open, ProtestStatus.Closed];
  const outcomes = [ProtestOutcome.Accepted, ProtestOutcome.Rejected, ProtestOutcome.Dismissed];
  const eventTypes = ["championship", "specialevent", "daily"];

  const [search, setSearch] = useState(props.protestSearchParameters);

  useEffect(() => {
    props.updated(search);
  }, [search]);


  return (
    <div>
      <Row>
        <Col>
          <Form.Group controlId="game">
            <Form.Label>Game:</Form.Label>
            <Form.Control as="select" value={search.game} onChange={(e) => setSearch({...search, game: e.target.value})}>
              <option value="">All</option> 
              {games.map((game) => (
                <option value={game} selected={search.game === game}>{game}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group controlId="game">
            <Form.Label>Search:</Form.Label>
            <Form.Control as="input" value={search.text} onChange={(e) => setSearch({...search, text: e.target.value})} />
          </Form.Group>
        </Col>

        <Col>
          <Form.Group controlId="eventype">
            <Form.Label>Event Type:</Form.Label>
            <Form.Control as="select" value={search.eventType} onChange={(e) => setSearch({...search, eventType: e.target.value})}>
              <option value="">All</option> 
              {eventTypes.map((eventType) => (
                <option value={eventType} selected={search.eventType === eventType}>{eventType}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group controlId="status">
            <Form.Label>Status:</Form.Label>
            <Form.Control as="select" value={search.status} onChange={(e) => setSearch({...search, status: parseInt(e.target.value)})}>
              <option value="">All</option> 
              {statuses.map((status) => (
                <option value={status} selected={search.status === status}>{protestStatusToText(status)}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group controlId="protestType">
            <Form.Label>Protest Type:</Form.Label>
            <Form.Control as="select" value={search.protestType} onChange={(e) => setSearch({...search, protestType: parseInt(e.target.value)})}>
              <option value="">All</option> 
              {protestTypes.map((protestType) => (
                <option value={protestType} selected={search.protestType === protestType}>{protestTypeToText(protestType)}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group controlId="outcome">
            <Form.Label>Outcome:</Form.Label>
            <Form.Control as="select" value={search.outcome} onChange={(e) => setSearch({...search, outcome: parseInt(e.target.value)})}>
              <option value="">All</option> 
              {outcomes.map((outcome) => (
                <option value={outcome} selected={search.outcome === outcome}>{protestOutcomeToText(outcome)}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>

    </div>
  );
}

export default MainSearchBarComponent;